/**
 * Norwegian labels for the Wiser recommendation widgets (M-20261022-produktside-tekst).
 * Wiser (app embed, wiser_2.0.js) translates its headings and buttons through window.__wsTranslations.nb, but
 * hardcodes its screen-reader labels and a few texts in English, and has no setting for them.
 * A known English aria-label, title, alt, placeholder or text inside a Wiser root gets its Norwegian one, at load
 * and whenever Wiser renders, rewrites an attribute or updates a text. Remove this file together with Wiser.
 */
(function () {
  'use strict';
  var NB = {
    'Next': 'Neste',
    'Previous': 'Forrige',
    'Left': 'Forrige',
    'Right': 'Neste',
    'Choose an option': 'Velg et alternativ',
    'Select this product': 'Velg dette produktet',
    'Quantity': 'Antall',
    'Decrease quantity': 'Reduser antall',
    'Increase quantity': 'Øk antall',
    'Close popup': 'Lukk',
    'Loading product bundle': 'Laster produktpakken',
    'Loading products...': 'Laster produkter...',
    'no image': 'Bilde mangler',
    'new': 'Nyhet',
    'Add': 'Legg til',
    'Buy Now': 'Kjøp nå',
    'Add to Wishlist': 'Legg til i ønskeliste',
    'Please select a variant for this product.': 'Velg en variant av dette produktet.',
    'Add to cart': 'Legg i handlekurv',
    'Add to Cart': 'Legg i handlekurv',
    'Added to cart!': 'Lagt i handlekurv!',
    'View cart': 'Vis handlekurv',
    'View Cart': 'Vis handlekurv',
    'Continue shopping': 'Fortsett å handle',
    'Continue shopping.': 'Fortsett å handle',
    'or': 'eller',
    'Choose Option': 'Velg alternativ',
    'Select a Variant': 'Velg variant',
    'Select a variant': 'Velg variant',
    'Total Price': 'Totalpris',
    'Total Price:': 'Totalpris:',
    'Frequently Bought Together': 'Ofte kjøpt sammen',
    'Recommended Products': 'Anbefalte produkter',
    'Related Products': 'Relaterte produkter',
    'Recently Viewed Products': 'Tidligere viste produkter',
    'New Arrivals': 'Nyheter',
    'Featured Products': 'Utvalgte produkter',
    'Trending Products': 'Populære produkter akkurat nå',
    'Inspired By Your Views': 'Inspirert av det du har sett',
    'Recommended For You': 'Anbefalt for deg',
    'Bundle discount will be applied at checkout': 'Pakkerabatten trekkes automatisk i kassen',
    'Shopping Cart': 'Handlekurv',
    'Your cart is empty.': 'Handlekurven din er tom.',
    'Subtotal': 'Delsum',
    'Checkout': 'Gå til kassen',
    'Estimate shipping': 'Beregn frakt',
    'Country': 'Land',
    'Shipping & taxes calculated at checkout': 'Frakt beregnes i kassen',
    'Do you want a gift wrap?': 'Vil du ha gaveinnpakning?',
    'Add A Gift Wrap': 'Legg til gaveinnpakning',
    'Edit Order Note': 'Merknad til bestillingen',
    'How can we help you?': 'Hva kan vi hjelpe deg med?',
    'Save': 'Lagre',
    'Cancel': 'Avbryt',
  };
  // Wiser labels its province and postcode fields "Country" too; the label's for= says which field it is.
  var FELT = { wsProvince: 'Fylke', wszipcode: 'Postnummer' };
  // aria-labels Wiser builds around a product title or a count, each on its own element type, so a product title
  // freed from "Product title: " on a link never meets the checkbox's "Select " rule.
  var MOENSTER = [
    ['A', /^Product title: ([\s\S]+)$/, '$1'],
    ['SELECT', /^Choose a variant for ([\s\S]+)$/, 'Velg variant for $1'],
    ['INPUT', /^Select ([\s\S]+)$/, 'Velg $1'],
    ['BUTTON', /^add to cart (\d+) selected [\s\S]* products ?$/, 'Legg $1 valgte produkter i handlekurven'],
  ];
  var ATTR = ['aria-label', 'title', 'alt', 'placeholder'];
  // Every element Wiser mounts a React root on: the targets its mount loop stamps data-widget-rendered, the widget
  // wrappers (also inside quick view and popups) carrying data-wiser-widget, its three fixed roots and its
  // cart-drawer custom elements.
  var WISER = '[data-wiser-widget],[data-widget-rendered],#evm_quickViewModel,#evmcartdrawer,#evmWiserWidegts,' +
    'cart-new-arrivals,cart-top-selling,cart-trending-products,cart-featured-collections,' +
    'cart-ai-based-recommendations,cart-manual-recommend-products,cart-recently-viewed-products,cart-related-products';

  // Own keys only, so a value naming an Object.prototype member is left as it is.
  function oppslag(v) {
    return Object.prototype.hasOwnProperty.call(NB, v) ? NB[v] : null;
  }

  function attrNorsk(el, navn) {
    var v = el.getAttribute(navn);
    if (v === null) return null;
    var nb = oppslag(v.trim());
    if (nb || navn !== 'aria-label') return nb;
    for (var i = 0; i < MOENSTER.length; i += 1) {
      var m = MOENSTER[i];
      if (el.tagName === m[0] && m[1].test(v)) return v.replace(m[1], m[2]);
    }
    return null;
  }

  // Matches the trimmed text and keeps its surrounding whitespace, so nothing moves.
  function tekstNorsk(node) {
    var m = /^(\s*)([\s\S]*?)(\s*)$/.exec(node.data);
    var kjerne = m[2];
    var nb = null;
    var forelder = node.parentElement;
    if (kjerne === 'Country' && forelder && FELT[forelder.getAttribute('for')]) nb = FELT[forelder.getAttribute('for')];
    else if (/^\d+ items$/.test(kjerne)) nb = kjerne.replace(/ items$/, kjerne === '1 items' ? ' vare' : ' varer');
    else nb = oppslag(kjerne);
    return nb ? m[1] + nb + m[3] : null;
  }

  function iWiser(el) {
    return !!(el && el.closest && el.closest(WISER));
  }

  function attr(el, navn) {
    var nb = attrNorsk(el, navn);
    if (nb !== null && iWiser(el)) el.setAttribute(navn, nb);
  }

  function tekst(node) {
    var nb = tekstNorsk(node);
    if (nb !== null && iWiser(node.parentElement)) node.data = nb;
  }

  // Everything below and including a node already known to be inside Wiser.
  function hele(node) {
    if (node.nodeType === 3) {
      tekst(node);
      return;
    }
    if (node.nodeType !== 1) return;
    for (var a = 0; a < ATTR.length; a += 1) if (node.hasAttribute(ATTR[a])) attr(node, ATTR[a]);
    for (var b = node.firstChild; b; b = b.nextSibling) hele(b);
  }

  function gjennomgaa(node) {
    if (node.nodeType === 3) {
      tekst(node);
    } else if (node.nodeType === 1) {
      if (iWiser(node)) {
        hele(node);
      } else {
        var rot = node.querySelectorAll(WISER);
        for (var i = 0; i < rot.length; i += 1) hele(rot[i]);
      }
    }
  }

  new MutationObserver(function (endringer) {
    for (var i = 0; i < endringer.length; i += 1) {
      var e = endringer[i];
      if (e.type === 'attributes') attr(e.target, e.attributeName);
      else if (e.type === 'characterData') tekst(e.target);
      else for (var j = 0; j < e.addedNodes.length; j += 1) gjennomgaa(e.addedNodes[j]);
    }
  }).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ATTR,
  });
  gjennomgaa(document.body);
})();
